export default __webpack_public_path__ + "static/media/Account-Activation-Guide.c885ab92.pdf";